import React from 'react';
import { QueueDisplay, RotationControl } from '../components/Queue';

const QueuePage: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h1 className="text-2xl font-bold text-gray-900">队列管理</h1>
        <p className="text-gray-600 mt-1">查看当前队列状态并进行轮换操作</p>
      </div>

      {/* Content */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <QueueDisplay />
        <RotationControl />
      </div>
    </div>
  );
};

export default QueuePage;